import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from './constants/colors';

const Input = styled.input`
  font-size: 16px;
  color: ${({ disabled }) => (disabled ? `${colors.lunarRays}` : `${colors.slateGrey}`)};
  fontweight: 450;
  border-radius: 8px;
  box-shadow: none;
  border: ${({ errorMessage }) =>
    errorMessage ? `1.5px solid ${colors.opalFlame}` : `1.5px solid ${colors.littleDipper}`};
  outline: none;
  display: block;
  height: 60px;
  min-width: 100%;
  box-sizing: border-box;
  max-width: 100%;
  background: ${colors.ghostWhite};
  text-indent: 16px;
  &:focus,
  &:hover {
    border: ${({ errorMessage, disabled }) => {
      if (disabled) return;
      if (errorMessage) {
        return `1.5px solid ${colors.opalFlame};`;
      }
      return `1.5px solid ${colors.tulleGrey}`;
    }};
  }
`;

Input.propTypes = {
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
};

Input.defaultProps = {
  disabled: false,
};

export default Input;
